import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/config/siteConfig";
import { scrollToId } from "@/lib/scroll";
import { Reveal, SectionHeading } from "@/components/Reveal";

const FILTER_MAP = {
  residential: { lookingFor: "Buy", type: "Residential", location: "", budget: "" },
  commercial: { lookingFor: "Buy", type: "Commercial", location: "", budget: "" },
  plots: { lookingFor: "Buy", type: "Plot", location: "", budget: "" },
  rental: { lookingFor: "Rent", type: "", location: "", budget: "" },
};

export const Categories = ({ onExplore }) => {
  const explore = (id) => {
    onExplore(FILTER_MAP[id]);
    scrollToId("#properties");
  };

  return (
    <section className="bg-white py-16 sm:py-24 lg:py-28" data-testid="property-categories">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          label="Categories"
          title="Find What You’re Looking For"
          subtitle="From a comfortable home to your next investment, explore properties by category."
        />

        <div className="mt-12 flex gap-4 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2 lg:grid lg:grid-cols-4 lg:gap-8 lg:overflow-visible lg:pb-0">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.08} className="min-w-[80vw] sm:min-w-[340px] lg:min-w-0 snap-start">
              <button
                onClick={() => explore(c.id)}
                data-testid={`category-card-${c.id}`}
                className="group relative w-full h-[420px] rounded-xl overflow-hidden text-left"
              >
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-108 group-hover:scale-110 transition-transform duration-[900ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/95 via-navy/35 to-navy/5 group-hover:via-navy/50 transition-all duration-500" />
                <div className="absolute inset-x-0 bottom-0 p-7">
                  <span className="text-[10px] font-bold tracking-[0.26em] text-gold uppercase">{c.tags.split("•")[0].trim()}</span>
                  <h3 className="mt-2 font-display text-2xl font-semibold text-white">{c.title}</h3>
                  <p className="mt-2 text-[13px] text-white/70 leading-relaxed">{c.desc}</p>
                  <p className="mt-3 text-[12px] text-white/55">{c.tags}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[13px] font-semibold text-gold border-b border-gold/60 pb-1 group-hover:gap-3.5 transition-all duration-300">
                    {c.cta} <ArrowUpRight size={15} />
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
